import danger from "@/img/icon-danger.svg";

import { useTranslation } from "react-i18next";

import "./style.scss";

export const App = () => {
	const { t } = useTranslation();

	return (
		<a className="weather-warning" href="/warnings">
			<div className="icon-wrapper">
				<span className="ring ring-1"></span>
				<span className="ring ring-2"></span>
				<span className="ring ring-3"></span>
				<img src={danger} alt="icon weather warning" />
			</div>

			<p className="label">{t("weatherWarning")}</p>
		</a>
	);
};

export default App;
